import "styles/pages/page-404.scss";
import React from "react";
import { Link } from "gatsby";
import Layout from "components/Layout";
import Seo from "components/Seo";

// markup
const NotFoundPage = () => {
  return (
    <Layout is404={true}>
      <Seo title="404 - strona nie istnieje" />
      <section className="error-section">
        <div className="container">
          <div className="error-section__text-container">
            <div className="error-section__text">
              Wyjechałeś <br />z kempingu!
            </div>
            <h1 className="error-section__title">
              404 <br />
              <span>strona nie istnieje</span>
            </h1>
          </div>
          <Link
            to="/"
            className="btn btn--with-icon btn--icon-right btn--strong"
          >
            &#171; Wróć
            <img src={require("assets/icons/car-left.svg").default} alt="" />
          </Link>
        </div>
      </section>
      <div className="error-page-footer">
        <div className="container">
          <div className="error-page-footer__text">
            &copy; 2021 Elcamp RV sp. z o.o. ul. Tyniecka 118e, 30-376 Kraków
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
